// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { productCarouselProductCondensedStyles } from "@guestsupply/Overrides/Components/ProductCarouselProductCondensed";
import { ellipsis } from "@guestsupply/XDL/Utilities";
import { css } from "styled-components";

productCarouselProductCondensedStyles.container = {
    gap: 4,
};

productCarouselProductCondensedStyles.imageGridItem = {
    width: 3,
};

productCarouselProductCondensedStyles.productBrandWrapper = {
    css: css`
        margin: 6px 0;
        min-height: 22px;
    `,
};

productCarouselProductCondensedStyles.productDetailsGridItem = {
    width: 7,
    css: css`
        flex-direction: column;
    `,
};

productCarouselProductCondensedStyles.productDescriptionStyles = {
    productDetailLink: {
        color: "text",
        typographyProps: {
            size: 12,
            lineHeight: "13px",
        },
        css: css`
            margin-bottom: 6px;
            line-height: 13px;
            ${ellipsis(3)}
        `,
    },
};

productCarouselProductCondensedStyles.productPartNumbersStyles = {
    container: {
        css: css`
            flex-grow: 0;
            margin-bottom: 6px;
        `,
    },
    erpNumberLabelText: { size: 12 },
    erpNumberValueText: { size: 12 },
};

productCarouselProductCondensedStyles.productPriceWrapper = {
    css: css`
        flex-grow: 1;
        margin-bottom: 6px;
    `,
};

productCarouselProductCondensedStyles.productUnitOfMeasureSelectStyles = {
    cssOverrides: {
        formField: css`
            margin-top: 6px;
        `,
    },
};

productCarouselProductCondensedStyles.addToCartContainer = {
    gap: 10,
    css: css`
        flex-grow: 0;
        margin-bottom: 6px;
    `,
};

productCarouselProductCondensedStyles.qtyGridItem = { width: 3 };

productCarouselProductCondensedStyles.productQuantityOrderedStyles = {
    cssOverrides: {
        formField: css`
            margin-top: 0;
        `,
    },
};

productCarouselProductCondensedStyles.addToCartButtonGridItem = { width: 9 };

productCarouselProductCondensedStyles.productAddToCartButtonStyles = {
    css: css`
        width: 100%;
    `,
};

productCarouselProductCondensedStyles.productAddToListLinkStyles = {
    link: {
        typographyProps: { size: 13 },
        css: css`
            margin-bottom: 12px;
        `,
    },
};

productCarouselProductCondensedStyles.condensedActionsTemplateGridItem = {
    width: 1,
};
